import { ArchiveConfirmationModalProvider } from '@/components/ConfirmationModal/Archive';
import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import { LoadingSkeleton } from '@/components/SkeletonLoading';
import { ReceivedInvoiceDetail } from '@/context/services/invoice/type';
import { HeaderButtons } from '@/features/invoices/components/Details/Components/Right/HeaderButton';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './DrawerTitle.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  data: ReceivedInvoiceDetail;
};

export const DrawerTitle: FC<Props> = memo(({ data }) => {
  return (
    <div className={cx(styles['container'])}>
      <div className={cx(styles['fileName-container'])}>
        <FileNameSeparatorWithExtension>
          {data.mf_file?.name ?? ''}
        </FileNameSeparatorWithExtension>
      </div>
      <div className={cx(styles['button-container'])}>
        <ArchiveConfirmationModalProvider>
          <HeaderButtons data={data} />
        </ArchiveConfirmationModalProvider>
      </div>
    </div>
  );
});
DrawerTitle.displayName = 'DrawerTitle';

export const LoadingDrawerTitle: FC = memo(() => {
  return (
    <div className={cx(styles['loading-container'])}>
      <LoadingSkeleton />
    </div>
  );
});

LoadingDrawerTitle.displayName = 'LoadingDrawerTitle';
